<template>
  <list-thumb-view />
</template>

<script>
export default {
  components: { ListThumbView: () => { return import('./ListThumbViewAlgolia') } }
}
</script>
